import { render, staticRenderFns } from "./applicant-card-home.vue?vue&type=template&id=ffc2edd2&scoped=true&"
import script from "./applicant-card-home.vue?vue&type=script&lang=js&"
export * from "./applicant-card-home.vue?vue&type=script&lang=js&"
import style0 from "./applicant-card-home.vue?vue&type=style&index=0&id=ffc2edd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc2edd2",
  null
  
)

export default component.exports